<template>
	<div class="m-user-avatar">
		<div class="bg-d">
			<div 
				v-if="showAvatar" 
				class="bg-c"
				:style="{backgroundImage:'url('+userIcon+')'}">
			</div>
		</div>
	</div>
</template>

<script>

import imgMixin from 'mixins/image'

export default {
	mixins: [imgMixin],
	props: {
		avatar: {
			type: String
		}
	},
	computed: {
		showAvatar() {
			return !Jt.string.isEmpty(this.avatar);
		}
	}
}

</script>


// WEBPACK FOOTER //
// user-avatar.vue?6c6ac04c